import lessRequire from '../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import cn from 'classname';

import SelectField from '../shared/form-elements/select';
import Targets from './targets';

import min from 'lodash/min';
import max from 'lodash/max';
import noop from 'lodash/noop';
import find from 'lodash/find';

lessRequire('modules/affiliates/entity.less');
lessRequire('modules/affiliates/offers.less');

import { getCurrencyIcon } from '../../../shared/js/get-currency-icon';

const Offers = props => {
	return (
		<tr className="offers-form__wrap">
			<td colSpan={5}>
				<table className="offers-form__table">
					<thead className="entity-wrap__table-head font-proxima-nova-semibold">
						<tr>
							<th className="offer-title">{props.intl('Офферы')}</th>
							<th className="geo">{props.intl('Гео')}</th>
							{props.payoutCurrencies.reduce((acc, { id }) => {
								acc.push(
									<th className="payout" key={acc.length}>{props.intl('Доход') + `, ${getCurrencyIcon(id)}`}</th>
								);
								acc.push(
									<th className="payout" key={acc.length}>{props.intl('Выпл.') + `, ${getCurrencyIcon(id)}`}</th>
								);
								return acc;
							}, [])}
							<td className="actions" />
						</tr>
					</thead>
					<tbody className="entity-wrap__table-body">
						{props.fields
							.map((parentName, index, fields) => {
								const res = [];

								const targetsAmount = props.fields.get(index)['targets'] && props.fields.get(index)['targets'].length;
								const shouldShowTargets =
									props.listOfActiveOffersPanIndex[props.parentIndex] &&
									props.listOfActiveOffersPanIndex[props.parentIndex].indexOf(index) > -1 &&
									!!targetsAmount;

								const shouldShowAddOfferButton =
									props.listOfAddedOffersPanIndex.indexOf(props.parentIndex) === -1 && !!props.addOfferOptions.length;

								const firstRowHeight = 76;
								const rowHeight = 50;
								const subtractOnHidePixelHeight = !targetsAmount
									? 0
									: index !== 0 || shouldShowAddOfferButton ? -((targetsAmount - 1) * rowHeight + firstRowHeight) : 0;
								const addOnShowPixelHeight = !targetsAmount
									? 0
									: index !== 0 || shouldShowAddOfferButton ? (targetsAmount - 1) * rowHeight + firstRowHeight : 0;

								const onToggleTargetsPan = props.fields.get(index)
									? shouldShowTargets
										? handleToggleTargets(
											props.parentIndex,
											props.hideOfferTargets,
											props.updateShownTargetsPixelHeights,
											subtractOnHidePixelHeight
										)
										: handleToggleTargets(
											props.parentIndex,
											props.showOfferTargets,
											props.updateShownTargetsPixelHeights,
											addOnShowPixelHeight
										)
									: noop;

								// offer row
								res.push(
									<Offer
										key={index}
										type="offer"
										parentName={parentName}
										parentIndex={props.parentIndex}
										index={index}
										intl={props.intl}
										payoutCurrencies={props.payoutCurrencies}
										placeholder={props.intl('Select offer')}
										fields={props.fields}
										entityOptions={props.entityOptions}
										onToggleTargetsPan={onToggleTargetsPan}
										className={cn({
											'is-show-targets': shouldShowTargets,
											'modify-cursor-pointer':
												props.fields.get(index)['targets'] && props.fields.get(index)['targets'].length,
											'last-offer': !shouldShowAddOfferButton && index === 0
										})}
										shouldShowTargets={shouldShowTargets}
										targetsAmount={targetsAmount}
										addOfferOptions={props.addOfferOptions}
										addOffer={props.addOffer}
										affiliate={props.affiliate}
										copyTerms={props.copyTerms}
									/>,
									<tr key={`offers-padding-${index}`} className="padding-tr" />
								);

								// targeting row
								shouldShowTargets &&
									res.push(
										<FieldArray
											name={`${parentName}.targets`}
											intl={props.intl}
											parentIndex={index}
											component={Targets}
											nullifiedBoosts={props.nullifiedBoosts}
											payoutCurrencies={props.payoutCurrencies}
											nullifyBoostOnSubmit={props.nullifyBoostOnSubmit}
										/>
									);

								return res;
							})
							.reverse()}

						{props.listOfAddedOffersPanIndex.indexOf(props.parentIndex) === -1 && !!props.addOfferOptions.length ? (
							<tr
								className="fields-wrap__add"
								onClick={() => {
									props.clickAddOffer(props.parentIndex);
									props.fields.unshift({});
								}}>
								<td colSpan={8}>
									<span className="font-proxima-nova-semibold">{props.intl('Подключить оффер')}</span>
								</td>
							</tr>
						) : null}
					</tbody>
				</table>
			</td>
		</tr>
	);
};

Offers.propTypes = {
	intl: PropTypes.func,
	fields: PropTypes.object,
	offersLookups: PropTypes.func,
	parentIndex: PropTypes.number,
	addOfferOptions: PropTypes.array,
	addOffer: PropTypes.func,
	clickAddOffer: PropTypes.func,
	listOfAddedOffersPanIndex: PropTypes.array,
	copyTerms: PropTypes.func,
	nullifyBoostOnSubmit: PropTypes.func,
	nullifiedBoosts: PropTypes.array
};

const Offer = ({
	className,
	parentIndex,
	payoutCurrencies,
	type,
	parentName,
	index,
	intl,
	fields,
	placeholder,
	entityOptions,
	onToggleTargetsPan,
	shouldShowTargets,
	targetsAmount,
	addOfferOptions,
	addOffer,
	affiliate,
	copyTerms
}) => {
	const rowOffer = fields.get(index).offer;
	const image = rowOffer && rowOffer.image;

	const firstRowHeight = 60;
	const rowHeight = 50;

	return (
		<tr className={`entity-offer ${className}`} onClick={e => onToggleTargetsPan(index)}>
			<td
				className={cn({
					'entity-type': true,
					'is-add-offer': !fields.get(index).offer
				})}>
				{shouldShowTargets && targetsAmount ? (
					<div
						className="vertical-line"
						style={{ height: targetsAmount ? firstRowHeight + (targetsAmount - 1) * rowHeight : firstRowHeight }}
					/>
				) : null}
				<Field
					name={`${parentName}.${type}`}
					placeholder={placeholder}
					image={image}
					component={SelectFieldWithImage}
					multi={false}
					shouldDisable={!!fields.get(index).offer}
					options={fields.get(index).offer ? entityOptions : addOfferOptions}
					onChange={offer => addOffer(offer, affiliate, parentIndex)}
					autoFocus={true}
					openOnFocus={true}
					searchable={true}
				/>
			</td>
			<td className="entity-geo">
				<span>{calculateTotalGeo(index, fields)}</span>
			</td>
			{payoutCurrencies.reduce((acc, { id }) => {
				acc.push(
					<td className="entity-revenue entity-revenue__last" key={acc.length}>
						<span>{calculateTotalRevenue(index, fields, id)}</span>
					</td>
				);
				acc.push(
					<td className="entity-payout"  key={acc.length}>
						<span>{calculateMinMaxPayout(index, fields, [id])}</span>
					</td>
				);
				return acc;
			}, [])}

			<td className="entity-actions">
				<div className="actions__wrap">
					{ false && targetsAmount > 0 && ( //commented, according cpa-1305
						<a
							className="copy-terms-link"
							href="#"
							onClick={e => {
								e.preventDefault();
								e.stopPropagation();
								confirm(
									intl(
										'Вы уверены, что хотите скопировать свои ставки этому вебмастеру по офферу %s?' +
									' Его текущие ставки сбросятся.',
										rowOffer.label
									)
								) && copyTerms(affiliate, rowOffer);
							}}>
							{intl('Копировать')}
						</a>
					) }
					<span className="toggle" />
				</div>
			</td>
		</tr>
	);
};

const calculateTotalGeo = (index, fields) => {
	const targets = fields.getAll()[index]['targets'] || [];
	return targets.filter(entity => entity.rub || entity.usd).length;
};

const calculateMinMaxPayout = (index, fields, currency = 'rub') => {
	const targets = fields.getAll()[index]['targets'] || [];
	const getAllAmount = targets.map(entity => +entity[currency]);
	const minValue = min(getAllAmount) || 0;
	const maxValue = max(getAllAmount) || 0;
	return `${minValue} - ${maxValue}`;
};

const calculateTotalRevenue = (index, fields, currency = 'rub') => {
	const offer = fields.getAll()[index]['offer'] || {};
	const offerRevenue = offer.revenue || [];
	const revenueForCurrency = find(offerRevenue, { currency }) || {};
	return revenueForCurrency.revenue ? parseInt(revenueForCurrency.revenue) : 0;
};

const SelectFieldWithImage = props => {
	return (
		<div>
			<SelectField {...props}>
				<img src={props.image || '//placehold.it/30x30'} alt="offer img" className="select-image select-image__offer" />
			</SelectField>
		</div>
	);
};

const handleToggleTargets = (parentIndex, handler, updateShownTargetsPixelHeights, targetsAmount) => index => {
	updateShownTargetsPixelHeights(parentIndex, targetsAmount);
	handler(index, parentIndex);
};

SelectFieldWithImage.propTypes = {
	image: PropTypes.string
};

Offer.propTypes = {
	className: PropTypes.string,
	type: PropTypes.string,
	parentName: PropTypes.string,
	index: PropTypes.any,
	parentIndex: PropTypes.number,
	intl: PropTypes.func,
	fields: PropTypes.object,
	placeholder: PropTypes.string,
	entityOptions: PropTypes.array,
	onToggleTargetsPan: PropTypes.func,
	shouldShowTargets: PropTypes.bool,
	targetsAmount: PropTypes.number,
	addOfferOptions: PropTypes.array,
	addOffer: PropTypes.func,
	affiliate: PropTypes.object,
	copyTerms: PropTypes.func
};

export default Offers;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/affiliates/offers.js